import React, { useEffect, useState } from "react";
import { supabase } from "./supabaseClient";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./ContentManager.css";

function ContentManager() {
  const [headings, setHeadings] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [formData, setFormData] = useState({
    title: "",
    subtitle: "",
    content: "",
    img_url: "",
  });

  const quillModules = {
    toolbar: [
      [{ header: [2, 3, false] }],
      ["bold", "italic", "underline"],
      ["link", "blockquote"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["clean"],
    ],
  };

  useEffect(() => {
    const fetchHeadings = async () => {
      const { data, error } = await supabase.from("headings").select("*");
      if (error) {
        console.error("Başlıklar çekilirken hata:", error);
      } else {
        setHeadings(data || []);
      }
    };

    fetchHeadings();
  }, []);

  const updateHeading = async () => {
    const { title, subtitle, content, img_url } = formData;

    if (!title || !subtitle || !content) {
      alert("Başlık, Alt Başlık ve İçerik boş bırakılamaz.");
      return;
    }

    const { error } = await supabase
      .from("headings")
      .update({ title, subtitle, content, img_url })
      .eq("id", editingId);

    if (error) {
      console.error("Başlık güncellenirken hata:", error);
    } else {
      setHeadings(
        headings.map((heading) =>
          heading.id === editingId
            ? { ...heading, title, subtitle, content, img_url }
            : heading
        )
      );
      setEditingId(null);
      setFormData({ title: "", subtitle: "", content: "", img_url: "" });
    }
  };

  const handleContentChange = (value) => {
    setFormData({ ...formData, content: value });
  };

  return (
    <div className="content-manager">
      <h1>Admin Panel - İçerik Yönetimi</h1>

      {headings.map((heading) => (
        <div key={heading.id} className="heading-item">
          {editingId === heading.id ? (
            <>
              <input
                type="text"
                value={formData.title}
                onChange={(e) =>
                  setFormData({ ...formData, title: e.target.value })
                }
                placeholder="Başlık"
              />
              <input
                type="text"
                value={formData.subtitle}
                onChange={(e) =>
                  setFormData({ ...formData, subtitle: e.target.value })
                }
                placeholder="Alt Başlık"
              />
              <ReactQuill
                value={formData.content}
                onChange={handleContentChange}
                modules={quillModules}
                placeholder="İçerik düzenle"
              />
              <input
                type="text"
                value={formData.img_url}
                onChange={(e) =>
                  setFormData({ ...formData, img_url: e.target.value })
                }
                placeholder="Resim URL"
              />
              <button onClick={updateHeading}>Kaydet</button>
              <button onClick={() => setEditingId(null)}>İptal</button>
            </>
          ) : (
            <>
              <h3>{heading.title}</h3>
              <p>{heading.subtitle}</p>
              <div
                dangerouslySetInnerHTML={{ __html: heading.content }}
                className="content-preview"
              ></div>
              {heading.img_url && (
                <img
                  src={heading.img_url}
                  alt={heading.title}
                  className="content-image"
                />
              )}
              <button
                onClick={() => {
                  setEditingId(heading.id);
                  setFormData({
                    title: heading.title,
                    subtitle: heading.subtitle,
                    content: heading.content,
                    img_url: heading.img_url,
                  });
                }}
              >
                Düzenle
              </button>
            </>
          )}
        </div>
      ))}
    </div>
  );
}

export default ContentManager;
